import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { styles } from '../../index';

const Well = React.forwardRef((props, ref) => {
  const classes = useStyles();
  return (
    <div {...props} className={classNames(classes.root, props.className)} ref={ref}>
      {props.children}
    </div>
  );
});

Well.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

const useStyles = styles.makeStyles(
  (theme) => ({
    root: {
      border: '1px solid #E7E9EC',
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    },
  })
);

export default Well;
